export default function HeroSection({ image = "nestroot-hero-cover.png" }: { image?: string }) {
  const finalImage = image.startsWith('/') ? (image.includes('nestroot') ? image : `/nestroot${image}`) : `/nestroot/${image}`;

  return (
    <section className="tw-relative tw-w-full tw-bg-white tw-overflow-hidden tw-h-[420px] sm:tw-h-[480px] md:tw-h-[550px] lg:tw-h-[500px] tw-flex tw-flex-col">

      {/* Background Image Container */}
      <div className="tw-absolute tw-inset-0 tw-z-10 tw-pointer-events-none">
        <img
          src={finalImage}
          alt="Nestroots Care Plan"
          className="tw-w-full tw-h-full tw-object-cover tw-object-right"
          onError={(e) => {
            (e.target as HTMLImageElement).src = '/nestroot/nestroot-hero-cover.png';
          }}
        />
        
        {/* Gradient Overlays */}
        {/* Mobile/Tablet: Vertical White Fade from Bottom */}
        <div className="tw-absolute tw-inset-0 tw-z-15 tw-bg-gradient-to-t tw-from-white tw-via-white/70 tw-to-transparent lg:tw-hidden" />
        
        {/* Desktop: Horizontal White Fade from Left */}
        <div className="tw-absolute tw-inset-0 tw-z-15 tw-hidden lg:tw-block tw-bg-gradient-to-r tw-from-white tw-via-white/90 tw-to-transparent tw-w-2/3" />
      </div>

      {/* Main Content */}
      <div className="tw-relative tw-z-20 tw-max-w-8xl tw-mx-auto tw-w-full tw-px-6 md:tw-px-12 tw-flex tw-items-end lg:tw-items-center tw-h-full tw-pb-10 sm:tw-pb-14 md:tw-pb-16 lg:tw-pb-0">
        
        {/* Text Block */}
        <div className="tw-w-full lg:tw-w-1/2 tw-text-center lg:tw-text-left">
          <h1 
            className="tw-text-[42px] sm:tw-text-5xl md:tw-text-6xl lg:tw-text-6xl xl:tw-text-[72px] tw-font-medium tw-text-black tw-leading-[1.1] tw-tracking-tight tw-mb-2 sm:tw-mb-4"
            style={{ fontFamily: "'Instrument Serif', serif" }}
          >
            Nestroots Care Plan.
          </h1>
          <p 
            className="tw-text-lg sm:tw-text-xl md:tw-text-2xl lg:tw-text-xl xl:tw-text-2xl tw-text-gray-800 tw-font-light tw-leading-relaxed tw-max-w-md tw-mx-auto lg:tw-mx-0 tw-opacity-90"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Protect your furniture. Extend its life. Enjoy peace of mind.
          </p>
        </div>
      </div>



    </section>
  );
}







